import { createStyles, makeStyles } from '@material-ui/core/styles';
import { colorsPalette } from '../../theme';

const useStyles = makeStyles(() => {
  return createStyles({
    container: {
      height: '100%',
      display: 'flex',
      flexDirection: 'column',
      background: colorsPalette.blueDark,
      flexGrow: 1,
    },
  });
});
export default useStyles;
